import { Grid, Typography } from '@mui/material'
import React from 'react'

export default function DropErrorForDayView() {
  return (
    <Grid container item xs={12} style={{ marginBottom: 20 }}>
      <Typography variant="h4">
        Drag and drop for events can not be done in day view. Please switch to Weekly/Monthly view.
      </Typography>
    </Grid>
  )
}
